import { Background, Image, ImageWrapper, Main, Tint } from './styles';
import { AuthLayoutMainProps } from './types';

const AuthLayoutMain = ({ children, background }: AuthLayoutMainProps) => {
  return (
    <Main>
      {background && (
        <Background>
          <Image data={background} layout="fill" />
          <Tint />
        </Background>
      )}
      {background && (
        <ImageWrapper>
          <Image data={background} layout="fill" />
        </ImageWrapper>
      )}
      {children}
    </Main>
  );
};
export default AuthLayoutMain;
